import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {DemandeModif} from './demande-modif.model';
import {DateUtils} from 'ng-jhipster';

@Injectable()
export class DemandeModifService {

    private resourceUrl = 'api/demande-modifs';
    private resourceUrlForEntity = 'api/demande-modifs/entity';
    private resourceUrlForEntityType = 'api/demande-modifs/entityType';

    private static convertResponse(res: any): any {
        res._body = res.json();
        return res;
    }

    constructor(private http: Http, private dateUtils: DateUtils) {

    }

    create(demandeModif: DemandeModif): Observable<DemandeModif> {
        let copy: DemandeModif = Object.assign({}, demandeModif);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(demandeModif: DemandeModif[]): Observable<DemandeModif[]> {
        let copyList: DemandeModif[] = [];
        demandeModif.forEach(c => {
            let copy: DemandeModif = Object.assign({}, c);
            copyList.push(copy);
        });
        if (copyList != null && copyList.length > 0) {
            return this.http.put(this.resourceUrl, copyList).map((res: Response) => {
                return res.json();
            });
        }
        return null;
    }

    find(id: number): Observable<DemandeModif> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return res.json();
        });
    }

    query(req?: any): Observable<Response> {
        if (req.candidatureFormationId != null) {
            return this.http.get(`${this.resourceUrlForEntity}/${req.candidatureFormationId}`)
                .map((res: any) => DemandeModifService.convertResponse(res))
                ;
        } else {
            if (req.entityType != null) {
                return this.http.get(`${this.resourceUrlForEntityType}/${req.entityType}`)
                    .map((res: any) => DemandeModifService.convertResponse(res))
                    ;
            }
        }
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/demande-modif/demande-modif.service.ts